// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.
import creditMemoPayments from './purchases-credit-memo-payments.js';

export default [
    {
        path: '/:organisation/payables/purchases-credit-memos',
        component: () =>
            import('@/pages/[organisation]/payables/purchases-credit-memos.vue'),
        name: 'accounts-payable.purchases-credit-memos.search-purchases-credit-memos',
        meta: {
            loginRequired: true,
            permission: 'access.payables.purchases-credit-memo.view-purchases-credit-memos',
        },

        children: [
            {
                path: ':id/update-purchases-credit-memo',
                component: () =>
                    import('@/pages/[organisation]/payables/purchases-credit-memos/[id]/update-purchases-credit-memo.vue'),
                name: 'accounts-payable.purchases-credit-memos.update-purchases-credit-memo',
                meta: {
                    loginRequired: true,
                    permission: 'purchases-credit-memo.edit',
                },
            },
            {
                path: ':id',
                component: () =>
                    import(/* webpackChunkName: "accounts-payable.purchases-credit-memos" */ '@/pages/[organisation]/payables/purchases-credit-memos/purchases-credit-memo/[id].vue'),
                name: 'accounts-payable.purchases-credit-memos.view-purchases-credit-memo',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.purchases-credit-memo.view-purchases-credit-memos',
                },
                children: [
                    {
                        path: 'new-payment',
                        component: () =>
                            import(/* webpackChunkName: "accounts-payable.purchases-credit-memo-payments" */ '@/pages/[organisation]/payables/purchases-credit-memo-payments/purchases-credit-memo-payment/new.vue'),
                        name: 'accounts-payable.purchases-credit-memo-payments.create-purchases-credit-memo-payment',
                        meta: {
                            loginRequired: true,
                            permission: 'access.payables.purchases-credit-memo.create-purchases-credit-memo-payment',
                        },
                    },
                ],
            },
            ...creditMemoPayments,
        ],
    },
];
